module.exports = __webpack_public_path__ + "static/img/ks.0629563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ks.png
// module id = fCL5
// module chunks = 7